
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { RecruitmentStatus } from "@/types/test-response";

interface RecruitmentStatusSelectProps {
  value: RecruitmentStatus;
  onChange: (value: RecruitmentStatus) => void;
  disabled?: boolean;
  className?: string;
}

export function RecruitmentStatusSelect({ 
  value, 
  onChange, 
  disabled = false,
  className 
}: RecruitmentStatusSelectProps) {
  // Ensure we have a valid value, defaulting to 'pending' if empty/null
  const safeValue = value || 'pending';
  
  return (
    <Select 
      value={safeValue} 
      onValueChange={(val) => onChange(val as RecruitmentStatus)} 
      disabled={disabled}
    >
      <SelectTrigger 
        className={`w-[130px] h-8 bg-card text-card-foreground ${className || ''}`}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-card border-border">
        <SelectItem 
          value="pending" 
          className="text-muted-foreground hover:bg-accent/50"
        >
          Pending
        </SelectItem>
        <SelectItem 
          value="shortlisted" 
          className="text-blue-pastel dark:text-blue-pastel font-medium hover:bg-accent/50"
        >
          Shortlisted
        </SelectItem>
        <SelectItem 
          value="hired" 
          className="text-green-500 dark:text-green-400 font-medium hover:bg-accent/50"
        >
          Hired
        </SelectItem>
        <SelectItem 
          value="rejected" 
          className="text-red-500 dark:text-red-400 font-medium hover:bg-accent/50"
        >
          Rejected
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
